module.exports = __webpack_public_path__ + "img/lea-31.6872855d.png";